import { useEffect, useState } from 'react';

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';

import { useAddContractContext } from '@/contexts/add-contract-context';

import { ChannelContent } from './channel-content';
import type { ContractSubmitSuccess } from './types';
import { FormattedMessage } from 'react-intl';

export function ContractForm() {
  const { isSheetOpen, setSheetOpen } = useAddContractContext();
  const [submitSuccess, setSubmitSuccess] =
    useState<ContractSubmitSuccess | null>(null);

  useEffect(() => {
    if (!isSheetOpen) {
      setSubmitSuccess(null);
    }
  }, [isSheetOpen]);

  return (
    <Sheet open={isSheetOpen} onOpenChange={setSheetOpen}>
      <SheetContent
        side="right"
        className="flex min-h-0 min-w-[550px] flex-col gap-0 overflow-hidden"
        onEscapeKeyDown={event => {
          // The open search popover owns Escape and restores its input focus.
          if (
            event.target instanceof Element &&
            event.target.closest('[data-contract-search-open]')
          ) {
            event.preventDefault();
          }
        }}
      >
        <div className="flex min-h-0 flex-1 flex-col">
          <SheetHeader className="shrink-0">
            <SheetTitle>
              <FormattedMessage
                defaultMessage="Add Contract"
                description="Sheet title: Add a new contract"
              />
            </SheetTitle>
          </SheetHeader>
          <ChannelContent
            submitSuccess={submitSuccess}
            onSubmitSuccess={setSubmitSuccess}
            onClose={() => setSheetOpen(false)}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
}
